import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useQuestionnaire } from '../context/QuestionnaireContext';

const { FiTarget, FiTrendingUp, FiCalendar, FiArrowRight } = FiIcons;

function WelcomePage() {
  const navigate = useNavigate();
  const { startQuestionnaire } = useQuestionnaire();

  const handleStart = () => {
    startQuestionnaire();
    navigate('/questionnaire');
  };

  return (
    <div className="min-h-screen flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-center max-w-4xl mx-auto"
      >
        {/* Header */}
        <div className="mb-12">
          <h1 
            style={{
      color: 'rgb(37, 99, 235)',
      fontSize: '24px'
    }} 
            className="text-5xl font-bold text-blue-600 mb-4"
          >Optimal AI + Marketing</h1>
          <h2 className="text-4xl font-bold text-gray-800 mb-2">
            2026 Business Gameplan
          </h2>
          <p className="text-xl text-gray-600 mb-4">
            Your Next 12-Month Action Plan
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-purple-600 mx-auto rounded-full"></div>
        </div>

        {/* Features */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.6 }}
          className="grid md:grid-cols-3 gap-8 mb-12"
        >
          <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-100">
            <SafeIcon icon={FiTarget} className="text-3xl text-blue-500 mb-4 mx-auto" />
            <h3 className="text-lg font-semibold text-gray-800 mb-2">Define Your Focus</h3>
            <p className="text-gray-600">Apply the Rule of 5 Ones to laser-focus your business strategy</p>
          </div>
          
          <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-100">
            <SafeIcon icon={FiTrendingUp} className="text-3xl text-green-500 mb-4 mx-auto" />
            <h3 className="text-lg font-semibold text-gray-800 mb-2">Set Clear Goals</h3>
            <p className="text-gray-600">Calculate revenue targets and daily action plans</p>
          </div>
          
          <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-100">
            <SafeIcon icon={FiCalendar} className="text-3xl text-purple-500 mb-4 mx-auto" />
            <h3 className="text-lg font-semibold text-gray-800 mb-2">Create Systems</h3>
            <p className="text-gray-600">Build sustainable daily, weekly, and monthly routines</p>
          </div>
        </motion.div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.6 }}
        >
          <p className="text-lg text-gray-600 mb-8">
            This comprehensive questionnaire will help you create a personalized business strategy 
            based on proven frameworks for sustainable growth.
          </p>
          
          <button
            onClick={handleStart}
            className="inline-flex items-center gap-3 bg-gradient-to-r from-blue-500 to-purple-600 text-white px-8 py-4 rounded-xl font-semibold text-lg hover:from-blue-600 hover:to-purple-700 transform hover:scale-105 transition-all duration-200 shadow-lg"
          >
            Start Your Gameplan
            <SafeIcon icon={FiArrowRight} className="text-xl" />
          </button>
          
          <p className="text-sm text-gray-500 mt-4">
            Takes approximately 10-15 minutes to complete
          </p>
        </motion.div>
      </motion.div>
    </div>
  );
}

export default WelcomePage;